/**
 * @description 문자열이 숫자로만 이루어져있는지 체크하는 함수
 * @returns boolean, (true: 숫자만 포함, false: 숫자 외 포함)
 */
const validateNumberOnly = (str: string) => {
  const regex = /^\d*$/;

  return regex.test(str);
};

export default validateNumberOnly;
